// Lightweight, safe markdown renderer for TRUSTED HomeRange AI output only.
// Supports: ## / ### headings, - / * bullets, 1. numbered lists, **bold**, paragraphs.
// Not for arbitrary user/HTML input.

function renderInline(text) {
  const RE = /(\*\*[^*]+\*\*|`[^`]+`|\[[^\]]+\]\s*\(https?:\/\/[^\s)]+\)|(?<![*\w])\*[^*\n]+\*(?!\*))/g;
  const parts = text.split(RE);
  return parts.map((p, i) => {
    if (!p) return null;
    if (/^\*\*[^*]+\*\*$/.test(p)) return <strong key={i} className="font-semibold">{p.slice(2, -2)}</strong>;
    if (/^`[^`]+`$/.test(p)) return <code key={i} className="px-1 py-0.5 bg-black/8 rounded text-[0.92em] font-mono">{p.slice(1, -1)}</code>;
    if (/^\*[^*\n]+\*$/.test(p)) return <em key={i} className="italic">{p.slice(1, -1)}</em>;
    const link = p.match(/^\[([^\]]+)\]\s*\((https?:\/\/[^\s)]+)\)$/);
    if (link) return <a key={i} href={link[2]} target="_blank" rel="noopener noreferrer" className="text-blaze underline underline-offset-2 break-words">{link[1]}</a>;
    return <span key={i}>{p}</span>;
  });
}

export function MarkdownLite({ text, className = "" }) {
  const lines = (text || "").split("\n");
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };

  lines.forEach((raw) => {
    const line = raw.trimEnd();
    if (!line.trim()) { flush(); return; }
    let m;
    if ((m = line.match(/^\s*#{2,4}\s+(.*)/))) { flush(); blocks.push({ type: "h", text: m[1] }); }
    else if ((m = line.match(/^\s*[-*]\s+(.*)/))) {
      if (!list || list.type !== "ul") { flush(); list = { type: "ul", items: [] }; }
      list.items.push(m[1]);
    } else if ((m = line.match(/^\s*\d+\.\s+(.*)/))) {
      if (!list || list.type !== "ol") { flush(); list = { type: "ol", items: [] }; }
      list.items.push(m[1]);
    } else { flush(); blocks.push({ type: "p", text: line }); }
  });
  flush();

  return (
    <div className={`space-y-2 text-sm leading-relaxed ${className}`}>
      {blocks.map((b, i) => {
        if (b.type === "h") return <p key={i} className="font-serif text-base mt-1 first:mt-0">{renderInline(b.text)}</p>;
        if (b.type === "p") return <p key={i}>{renderInline(b.text)}</p>;
        if (b.type === "ul") return <ul key={i} className="list-disc pl-5 space-y-1">{b.items.map((it, j) => <li key={j}>{renderInline(it)}</li>)}</ul>;
        if (b.type === "ol") return <ol key={i} className="list-decimal pl-5 space-y-1">{b.items.map((it, j) => <li key={j}>{renderInline(it)}</li>)}</ol>;
        return null;
      })}
    </div>
  );
}
